import AbstractSpecification from "./AbstractSpecification.js";

/**
 * `abstractCompositeSpecification` is an abstract superclass
 * of `andSpecification` and `orSpecification`. It contains a
 * list of child specifications.
 *
 * @abstract
 * @param {AbstractSpecification[]} spec.specifications - List of specifications
 */
export default class AbstractCompositeSpecification extends AbstractSpecification {
	constructor(spec = {}) {
		super(spec);
		this._specifications = spec.specifications;
	}

	getSpecifications() {
		return this._specifications;
	}

	leaves() {
		return this._specifications.reduce((acc, spec) => {
			acc.push(...spec.leaves());
			return acc;
		}, []);
	}

	_serializedProperties() {
		const schema = super._serializedProperties();

		schema.specifications = this._specifications;

		return schema;
	}

	static transformMaterializationData(data, context) {
		data.specifications = context.factory.materializeAll(
			data.specifications,
		);
	}
}
